module.exports = __webpack_public_path__ + "static/bg-mobile-9bf7759d754b08c91167420ec461b97f.jpg";